(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    /*
   * Solstice: in the full-screen view on desktop, each photo is shown whole. Clicking a
   * photo zooms in where you clicked and follows the mouse; clicking again zooms out.
   * The dialog closes with the X button or Esc. Phones keep pinch to zoom.
   */
  (() => {
    if (window.__solsticeZoomPreview) return;
    window.__solsticeZoomPreview = true;
    const desktop = window.matchMedia('(min-width: 750px)');
    const ZOOM = 2.5;

    const setOrigin = (item, event) => {
      const image = item.querySelector('img');
      if (!image) return;
      const box = image.getBoundingClientRect();
      const x = ((event.clientX - box.left) / box.width) * 100;
      const y = ((event.clientY - box.top) / box.height) * 100;
      item.style.setProperty('--zoom-x', `${Math.min(100, Math.max(0, x))}%`);
      item.style.setProperty('--zoom-y', `${Math.min(100, Math.max(0, y))}%`);
    };

    document.addEventListener(
      'click',
      (event) => {
        if (!desktop.matches || !(event.target instanceof Element)) return;
        const item = event.target.closest('.dialog-zoomed-gallery .product-media-container--image');
        if (!item) return;
        event.stopPropagation();
        event.preventDefault();
        const zoomed = item.classList.toggle('is-zoomed');
        item.style.setProperty('--zoom-scale', zoomed ? String(ZOOM) : '1');
        if (zoomed) setOrigin(item, event);
      },
      true
    );

    document.addEventListener('mousemove', (event) => {
      if (!desktop.matches || !(event.target instanceof Element)) return;
      const item = event.target.closest('.dialog-zoomed-gallery .product-media-container--image.is-zoomed');
      if (item) setOrigin(item, event);
    });

    // Zoom out again whenever the dialog closes.
    document.addEventListener(
      'close',
      (event) => {
        if (!(event.target instanceof Element)) return;
        event.target.querySelectorAll?.('.dialog-zoomed-gallery .is-zoomed').forEach((item) => {
          item.classList.remove('is-zoomed');
          item.style.setProperty('--zoom-scale', '1');
        });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fabric-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fabric-swatches')) {
    class FabricSwatches extends HTMLElement {
      connectedCallback() {
        this.label = this.querySelector('.fabric-swatches__name');
        this.selectedName = '';
        this.addEventListener('click', (event) => {
          const swatch = event.target instanceof Element ? event.target.closest('.fabric-swatches__swatch') : null;
          if (!swatch) return;
          for (const other of this.querySelectorAll('.fabric-swatches__swatch')) {
            other.setAttribute('aria-pressed', String(other === swatch));
          }
          this.selectedName = swatch.dataset.name || '';
          this.show(this.selectedName);
        });
        // With a mouse, pointing at a swatch previews its name.
        this.addEventListener('pointerover', (event) => {
          if (event.pointerType !== 'mouse') return;
          const swatch = event.target instanceof Element ? event.target.closest('.fabric-swatches__swatch') : null;
          if (swatch) this.show(swatch.dataset.name || '');
        });
        this.addEventListener('pointerleave', () => this.show(this.selectedName));
      }

      show(name) {
        if (this.label) this.label.textContent = name;
      }
    }
    customElements.define('fabric-swatches', FabricSwatches);
  }
  } catch(e) { console.error(e); }
})();

})();
